<template>
  <div>
    <div>
      <vx-card>
        <div class="mt-5" v-if="dadosOuvidoria != {}">
          <h3 class="mb-6">
            Ouvidoria {{ dadosOuvidoria.ouvidoria.id_ouvidoria }}
          </h3>
          <div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="person" title="Nome">
                    {{ dadosOuvidoria.ouvidoria.nome }}
                  </vs-list-item>
                  <vs-list-item icon="badge" title="CPF/CNPJ">
                    {{ dadosOuvidoria.ouvidoria.cpfCnpj }}
                  </vs-list-item>
                  <vs-list-item icon="phone" title="Telefone">
                    {{ dadosOuvidoria.ouvidoria.telefone }}
                  </vs-list-item>
                  <vs-list-item icon="mail" title="Email">
                    {{ dadosOuvidoria.ouvidoria.email }}
                  </vs-list-item>
                  <vs-list-item icon="directions_car" title="Placa">
                    {{ dadosOuvidoria.ouvidoria.placa }}
                  </vs-list-item>
                </vs-list>
              </div>
              <div class="vx-col sm:w-1/2 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="find_in_page" title="Protocolo">
                    {{
                      new Date(
                        dadosOuvidoria.ouvidoria.createdAt,
                      ).getFullYear()
                    }}{{ dadosOuvidoria.ouvidoria.idOuvidoria }}
                  </vs-list-item>
                  <vs-list-item icon="help" title="Tipo de apontamento">
                    {{
                      dadosOuvidoria.ouvidoria
                        .Ouvidoria_domTiposIdentificacaoOuvidoria
                        ? dadosOuvidoria.ouvidoria
                            .Ouvidoria_domTiposIdentificacaoOuvidoria
                            .tipoIdentificacao
                        : 'Não preenchido'
                    }}
                  </vs-list-item>
                  <vs-list-item icon="place" title="Cidade / Estado">
                    {{ dadosOuvidoria.ouvidoria.cidade }} /
                    {{ dadosOuvidoria.ouvidoria.estado }}
                  </vs-list-item>
                  <vs-list-item icon="apartment" title="Setor">
                    {{
                      dadosOuvidoria.ouvidoria.Ouvidoria_Setor
                        ? dadosOuvidoria.ouvidoria.Ouvidoria_Setor.nomeSetor
                        : 'Não preenchido'
                    }}
                  </vs-list-item>
                  <vs-list-item icon="date_range" title="Data da Ouvidoria">
                    {{ formataData(dadosOuvidoria.ouvidoria.createdAt) }}
                  </vs-list-item>
                </vs-list>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-list>
                  <vs-list-item icon="forum" title="Assunto">
                    <div v-html="dadosOuvidoria.ouvidoria.assunto"></div>
                  </vs-list-item>
                  <vs-list-item icon="forum" title="Mensagem">
                    <div v-html="dadosOuvidoria.ouvidoria.mensagem"></div>
                  </vs-list-item>
                </vs-list>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/1 w-full mb-2">
                <vs-list> </vs-list>
              </div>
            </div>

            <vs-list>
              <vs-list-header
                color="#202020"
                title="Histórico"
              ></vs-list-header>
              <vs-list-item
                icon="reply"
                v-bind:title="item.OuvidoriaResposta_Usuarios.nome"
                v-bind:subtitle="formataData(item.createdAt)"
                style="overflow: auto"
                v-for="item in historicoLista"
                :key="item.id_ouvidoriaResposta"
              >
                {{ item.resposta }}
              </vs-list-item>

              <vs-list-header
                class="mt-6"
                color="#202020"
                title="Histórico Interno"
              ></vs-list-header>
              <vs-list-item
                v-for="item in historicoInternoLista"
                :key="item.id_ouvidoriaResposta"
                icon="reply"
                v-bind:title="item.OuvidoriaResposta_Usuarios.nome"
                v-bind:subtitle="formataData(item.createdAt)"
                style="overflow: auto"
              >
                {{ item.historicoInterno }}
              </vs-list-item>
            </vs-list>
            <form role="form" @submit.stop.prevent autocomplete="off">
              <div class="vx-row">
                <div class="vx-col w-full mt-6 mb-2">
                  <vs-textarea
                    label="Histórico"
                    v-model="form.novaResposta"
                    name="Histórico"
                    v-validate="{ required: true }"
                    :state="validateState('Histórico')"
                    :danger="validateClass('Histórico')"
                  />
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full mb-2">
                  <vs-textarea
                    label="Histórico Interno"
                    v-model="form.historicoInterno"
                    name="Historico Interno"
                    :state="validateState('Historico Interno')"
                    :danger="validateClass('Historico Interno')"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </vx-card>
      <div class="vx-row mt-3">
        <div
          v-if="precisaAlterarProduto == false"
          class="vx-col w-full text-right"
        >
          <form role="form" @submit.stop.prevent="onSubmit">
            <BotaoSubmit
              variant="success"
              :edit="false"
              :aguarde="aguardeCadastro"
            ></BotaoSubmit>
          </form>
        </div>
        <div v-else class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click="passo = 3"
            >Buscar e Atualizar Produtos</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../../services';
import locale from './../../../locale';
import moment from 'moment';
import BotaoSubmit from '../../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
export default {
  components: {
    BotaoSubmit,
  },
  data() {
    return {
      aguardeCadastro: false,
      dadosOuvidoria: {
        ouvidoria: {
          Ouvidoria_Setor: {},
          tipoIdentificacao: {},
        },
        respostas: [],
      },
      precisaAlterarProduto: false,
      regionais: [],
      consultores: [],
      status: [],
      grupos: [],
      listaCores: [],
      listaCombustiveis: [],
      fotos: [],
      form: {
        novaResposta: '',
        historicoInterno: '',
      },
      passo: 0,
      historicoInternoLista: [],
      historicoLista: [],
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          var user = this.buscaUsuario();
          if (!user) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: `Problemas ao Buscar o Usuário`,
              color: 'danger',
            });
            return;
          }
          var obj = {
            resposta: this.form.novaResposta,
            historicoInterno: this.form.historicoInterno,
            idOuvidoria: this.$route.params.idOuvidoria,
            idEmpresa: null,
            idAutor: user,
          };
          this.$vs.loading();
          service
            .post('Ouvidoria', 'inserirRespostaOuvidoria', obj)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Obrigado',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.form.novaResposta = '';
              this.form.historicoInterno = '';
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        } else {
          this.$validator.errors.items.forEach((item) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: item.msg,
              color: 'danger',
            });
          });
        }
      });
    },

    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idOuvidoria = this.$route.params.idOuvidoria;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('Ouvidoria', 'listarRespostasOuvidoria', objSend)
        .then((res) => {
          if (res.data.ouvidoria) {
            this.dadosOuvidoria = res.data;
            for (let index in this.dadosOuvidoria.ouvidoria) {
              if (
                !this.dadosOuvidoria.ouvidoria[index] &&
                ![
                  'Ouvidoria_Setor',
                  'Ouvidoria_domTiposIdentificacaoOuvidoria',
                ].includes(index)
              ) {
                this.dadosOuvidoria.ouvidoria[index] = 'Não preenchido';
              }
            }

            this.historicoInternoLista = this.dadosOuvidoria.respostas.filter(
              (item) => item.historicoInterno,
            );
            this.historicoLista = this.dadosOuvidoria.respostas.filter(
              (item) => item.resposta,
            );
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Você não tem acesso a visualização desta Ouvidoria',
              color: 'danger',
            });
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaUsuario() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        return decoded.id_usuario;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.$validator.localize('ptBr', locale);
    localStorage.removeItem('formFiltro');
    this.buscaDados();
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
